import { Redirect } from 'expo-router';

import LoyaltyDashboardPage from '@fhs-legacy/frontend/src/pages/loyalty/loyalty-dashboard';
import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function DetailsPage() {
  const enableRewardsTiers = useFlag(LaunchDarklyFlag.ENABLE_REWARDS_TIERS) as boolean;
  if (enableRewardsTiers) {
    return <Redirect href={`${routes.offersV2}?section=rewards`} />;
  }

  return <LoyaltyDashboardPage />;
}
